import * as React from "react";
import { setDatasource } from "#store/ui";
import { useAppDispatch, useAppSelector } from "#store";
import { selectDatasources } from "#selectors";
import { P } from "#common/headings";
import { DatasourceDto } from "#/services/pilotService/types";
import { MenuItem, TextField, Tooltip } from "@mui/material";

export default function DatasourceSelector() {
    const datasources = useAppSelector(selectDatasources);
    const currentSource = useAppSelector(
        state => state.uiState.selectedDatasource
    );

    const dispatch = useAppDispatch();

    const handleMenuItemClick = (value: string) => {
        dispatch(setDatasource(value));
    };
    if (datasources.length === 0) {
        return <P>Currently no datasources are available.</P>;
    }

    return (
        <Tooltip title="Select Datasource">
            <TextField
                variant={"standard"}
                select
                value={currentSource.name}
                onChange={event => {
                    handleMenuItemClick(event.target.value);
                }}
            >
                {datasources.map(option => (
                    <MenuItem key={option.name} value={option.name}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
        </Tooltip>
    );
}
